import { teamCanSeeEntity } from '../../domain/entity/entityVision.js';

/**
 * Agent smoke: shared team vision query (FID-VIS-01 / FID-VIS-05).
 */
export function attachTeamCanSeeHook(win, {
  getPlayer,
  getAlliedViewers,
  getWallBoxes,
  getBushZones,
  matchRuntime
} = {}) {
  if (!win) return;
  win.__debugTeamCanSee = (target) => {
    const p = typeof getPlayer === 'function' ? getPlayer() : null;
    if (!p || !target) return false;
    const extras = typeof getAlliedViewers === 'function' ? getAlliedViewers() : [];
    const wallBoxes = typeof getWallBoxes === 'function' ? getWallBoxes() : [];
    const bushZones = typeof getBushZones === 'function' ? getBushZones() : [];
    return teamCanSeeEntity(
      p.team || 'blue',
      target,
      [p, ...(extras || [])],
      bushZones || [],
      matchRuntime?.activeWards || [],
      wallBoxes || []
    );
  };
}
